import { QUERY_KEY } from 'constants/globalConstants'
import ApiService from 'apiService'
import { useQuery } from 'react-query'

const useEntityList = (status, pageSize, currentPage) => {
    return useQuery(QUERY_KEY.GET_ELITE_LIST, () => ApiService.getEntityList(status, pageSize, currentPage), {retry: false})
}

export default useEntityList